var twig = require("twig").twig,
    tokens = [],
    template = twig({"id":"$resolved:fd667d11a4c258232ae9f3dba80a3b149696f850459483d6a8ef35244381d97a1b0af1f36a712e080b5ed89f53d2af8a78e19e7869c648a67aa08691c5452e8b:arrow-left.svg.twig","data":[],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;